export function noop(..._args: ReadonlyArray<unknown>): void {}
